export default "__VITE_PUBLIC_ASSET__ee4ee128__"